import { Button, ButtonGroup, Card, CircularProgress, Grid, Hidden } from '@material-ui/core';
import './wipStyles.scss';

export const EWIPDates = ({ state, classes, WipsDate, array, handleDate, handleChangeByTime, getDateObj, onChartClickHandler }) => {
    const dateTotal = (getDateObj || []).reduce((acc, item) => acc + (Number(item?.value) || 0), 0);

    return (
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <div className="pieChartSize" style={{ display: 'flex' }}>
                        <CircularProgress className="wip-loader" />
                    </div>
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <Hidden only={['xs']}>
                                <div className="dash-segmented-group">
                                    {WipsDate.map((n) => (
                                        <button
                                            type="button"
                                            key={n.id}
                                            className={`dash-segmented-btn ${array.assignedDate === n.id ? 'active' : ''}`}
                                            onClick={() => handleDate(n.id)}
                                        >
                                            {n.name}
                                        </button>
                                    ))}
                                </div>
                            </Hidden>
                            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                                <select onChange={handleDate} className="selectclass" value={array.assignedDate} style={{ maxWidth: '140px' }}>
                                    {WipsDate.map((n, i) => (
                                        <option key={i} value={n.id}>
                                            {n.name}
                                        </option>
                                    ))}
                                </select>
                            </Hidden>
                            <span className="dash-heading-total">( Total : {dateTotal} )</span>
                        </div>
                    </div>

                    <div className="dash-stat-tiles-row wip-date-grid">
                        {getDateObj.map((item, index) => (
                            <div
                                className="dash-stat-tile-col"
                                key={item.label || index}
                                onClick={() =>
                                    onChartClickHandler(
                                        {
                                            workflowID: 'All',
                                            workflow: array.byTimeObj?.workflow,
                                            bn: array.byTimeObj?.bn,
                                            time: item.time,
                                            dueTime: item.dueTime
                                        },
                                        true
                                    )
                                }
                            >
                                <div
                                    // style={{
                                    //     borderLeft: item.BarColor || '6px solid #183B68'
                                    // }}
                                    className="dash-stat-tile"
                                    title={item.label}
                                >
                                    <span className="lableFont">{item.label}</span>
                                    <div className="valueFont">{item.value || 0}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>
            )}
        </>
        // </Grid>
    );
};
